// extracted by mini-css-extract-plugin
module.exports = {"projectDetailsContainer":"ProjectDetails_projectDetailsContainer__gWWig","projectDetailsSkeleton":"ProjectDetails_projectDetailsSkeleton__gJnbh"};